<template>
    <span class="eq-wrapper">
        <span v-for="n in bars" :key="n" class="eq-bar" :style="{ animationDelay: `${(n - 1) * 120}ms` }" />
    </span>
</template>

<script>
export default {
    data() {
        return {
            bars: 4
        }
    }
}
</script>
<style scoped>
.eq-wrapper {
    display: inline-flex;
    gap: 2px;
    font-size: 16px;
    line-height: 1;
}

.eq-bar {
    width: 3px;
    height: 1em;
    background: currentColor;
    border-radius: 2px;
    transform-origin: bottom;
    animation: equalize 0.9s ease-in-out infinite;
}

@keyframes equalize {

    0%,
    100% {
        transform: scaleY(0.25);
    }

    40% {
        transform: scaleY(1);
    }

    80% {
        transform: scaleY(0.4);
    }
}
</style>